import formatCurrency from "Utils/formatCurrency";
import { isMinimalPlan } from "Utils/plansUtils";

// Return the simplified plan name (plan metal tier, plan type, plan deductible)
// This should only be simplified for standard plans, not MEC/MVP
export function simplifyPlanName(plan) {
  if (isMinimalPlan(plan)) {
    return formatMinimalPlanName(plan);
  }
  return planNameAndDeductible(plan).join(" ");
}

export function formatMinimalPlanName(plan) {
  if (plan.target_market == "mec") return plan.display_name.replace("MEC", "Minimum Essential Coverage");
  if (plan.target_market == "mvp") return plan.display_name.replace("MVP", "Minimum Value Plan");
  return plan.display_name;
}

export function planNameAndDeductible(plan) {
  return [planName(plan), planDeductible(plan)];
}

export function planDeductible(plan) {
  let costText;
  if (plan.type === "medical") {
    costText = `${formatCurrency(plan.deductible)}`;
  } else {
    costText = plan.deductible;
  }
  return costText;
}

export function planName(plan) {
  let planName;
  let prefix;
  if (plan.type === "medical" && !isMinimalPlan(plan)) {
    prefix = `${plan.metal_tier[0].toUpperCase() + plan.metal_tier.slice(1)}`;
    planName = [prefix, plan.plan_type].filter((x) => x).join(" ");
  } else {
    planName = plan.full_display_name || plan.display_name;
  }
  return planName;
}

export default simplifyPlanName;
